import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('fromNumberToFormatted'); // eslint-disable-line no-unused-vars

const DEFAULT = '';

const NF = (() => {
  try {
    // noinspection JSCheckFunctionSignatures
    return new Intl.NumberFormat(void 1, { useGrouping: 'always', minimumSignificantDigits: 1 });
  } catch (e) {
    L.warn('()', e);
  }
})();

const fromNumberToFormatted = (n) => {
  try {
    if (!NF) return fromAnyToString(n);

    if (null === n || void 1 === n || '' === n || 'symbol' === typeof n) return DEFAULT;

    // check if the argument passed is a number or string or a String
    // format a good number, maybe format a string, browser seems to support it if it can convert it
    const formatted = Number.isFinite(n) || String(n) === n ? NF.format(n) : DEFAULT;

    return 'NaN' !== formatted ? formatted : fromAnyToString(n);
  } catch (e) {
    L.warn('()', e);
    return fromAnyToString(n);
  }
};

export default fromNumberToFormatted;
